
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(99(18|37)5|(122|3630|4261)9|26771|29073|80456)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
